function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useMemo } from "react";
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
import { rgba } from "../../../utils/styleUtils";
import { boxShadowFocus } from "../../../utils/css/cssFor/cssFor";
var buildStyle = function(theme, param, param1) {
    var readingDirection = param.readingDirection, start = param.start, typographyUpdates = param1.typographyUpdates;
    var _backgroundColor = theme.backgroundColor, _borderColor = theme.borderColor, depth = theme.depth, font = theme.font, size = theme.size, spacing = theme.spacing, experimentalBlocks = theme.experimentalBlocks;
    var ref;
    var backgroundColor = (ref = experimentalBlocks === null || experimentalBlocks === void 0 ? void 0 : experimentalBlocks.backgroundColor) !== null && ref !== void 0 ? ref : _backgroundColor;
    var _color;
    var fontColor = (_color = experimentalBlocks === null || experimentalBlocks === void 0 ? void 0 : experimentalBlocks.font.color) !== null && _color !== void 0 ? _color : font.color;
    var ref1;
    var borderColor = (ref1 = experimentalBlocks === null || experimentalBlocks === void 0 ? void 0 : experimentalBlocks.borderColor) !== null && ref1 !== void 0 ? ref1 : _borderColor;
    return {
        'option-container-styles': {
            fontFamily: font.base.family,
            fontStyle: 'normal',
            fontWeight: font.base.weight.regular,
            letterSpacing: 'normal',
            lineHeight: font.lineHeight.base,
            textAlign: start.direction,
            textIndent: 0,
            textShadow: 'none',
            textTransform: 'none',
            backgroundColor: backgroundColor.base,
            boxSizing: 'border-box',
            position: 'relative',
            width: '100%'
        },
        'option-destructive': {
            color: fontColor.danger.base,
            '&:focus-visible.optionFocused': {
                backgroundColor: rgba(backgroundColor.danger.surface, depth.opacity.heavy)
            },
            '& g': {
                fill: fontColor.danger.base
            },
            '& div span': {
                color: backgroundColor.danger.base
            },
            '&:focus': {
                backgroundColor: rgba(backgroundColor.danger.surface, depth.opacity.heavy),
                color: fontColor.danger.hover,
                '& g': {
                    fill: fontColor.danger.hover
                },
                '& div span': {
                    color: fontColor.danger.hover
                }
            },
            '&:active': {
                backgroundColor: backgroundColor.danger.active,
                color: fontColor.danger.hover,
                '& g': {
                    fill: fontColor.danger.hover
                },
                '& div span': {
                    color: fontColor.danger.hover
                }
            }
        },
        'option-disabled': {
            opacity: depth.opacity.light,
            '&:hover, &:focus': {
                backgroundColor: backgroundColor.base
            },
            cursor: 'not-allowed'
        },
        'option-first-option-heading': {
            borderTop: 'none'
        },
        'option-heading': {
            textTransform: 'uppercase',
            fontSize: font.base.size.xxs,
            fontWeight: typographyUpdates ? font.base.weight.medium : font.base.weight.bold,
            color: fontColor.soft,
            borderTop: "".concat(size.border.base, "px solid ").concat(borderColor.soft),
            cursor: 'default',
            paddingTop: 0,
            paddingBottom: 0,
            marginTop: 10,
            marginBottom: 6,
            minHeight: spacing[5],
            '&[role="separator"]:not(:first-of-type)': {
                paddingTop: 10,
                marginTop: spacing[3],
                height: '100%',
                marginLeft: 0,
                marginRight: 0,
                paddingLeft: spacing[5],
                paddingRight: spacing[5],
                width: '100%'
            }
        },
        'option-check-style': {
            alignItems: 'center',
            display: 'flex',
            visibility: 'hidden'
        },
        'option-row-style': {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%'
        },
        'option-label-container': {
            display: 'flex',
            alignItems: 'start'
        },
        'option-line-break': {
            borderTop: "".concat(size.border.base, "px solid ").concat(borderColor.soft),
            marginTop: spacing[3],
            marginBottom: spacing[3],
            width: '100%'
        },
        'option-list-item': _objectSpread({}, readingDirection, {
            fontFamily: font.base.family,
            fontStyle: 'normal',
            fontWeight: font.base.weight.regular,
            letterSpacing: 'normal',
            textIndent: 0,
            textShadow: 'none',
            textTransform: 'none',
            textAlign: start.direction,
            lineHeight: font.lineHeight.base,
            appearance: 'none',
            backgroundColor: backgroundColor.clickNeutral.base,
            borderRadius: size.border.radius.threeX,
            boxSizing: 'border-box',
            color: fontColor.base,
            cursor: 'pointer',
            flexWrap: 'wrap',
            fill: fontColor.base,
            fontSize: font.base.size[3],
            margin: "0 ".concat(spacing[3]),
            outline: 0,
            padding: spacing[3],
            position: 'relative',
            width: "calc(100% - ".concat(spacing[5], ")"),
            display: 'flex',
            flexShrink: 0,
            flexGrow: 0,
            border: 'none',
            flexDirection: 'column',
            alignItems: 'flex-start',
            '&::-moz-focus-inner': {
                border: 0
            },
            '&:focus-visible.optionFocused': _objectSpread({}, boxShadowFocus('borderColor', theme, true), {
                backgroundColor: rgba(backgroundColor.clickNeutral.hover, depth.opacity.light)
            }),
            '&:hover': {
                backgroundColor: backgroundColor.clickNeutral.surface
            },
            '&:active': {
                backgroundColor: rgba(backgroundColor.clickNeutral.active, depth.opacity.light)
            }
        }),
        'option-list-item-heading': {
            borderRadius: 0,
            cursor: 'default'
        },
        'option-list-item-bg': {
            '> li': {
                backgroundColor: backgroundColor.disabled,
                border: 'none',
                outline: 'none'
            }
        },
        'option-list-item-bg-unset': {
            '&:hover, &:focus, &:active': {
                backgroundColor: 'unset'
            }
        },
        'option-list-item-selected': {
            backgroundColor: backgroundColor.interactive.active,
            color: fontColor.interactive.active,
            '> div > :last-child': {
                visibility: 'visible'
            },
            '&:hover, &:focus-visible.optionFocused': {
                backgroundColor: backgroundColor.interactive.active
            }
        },
        'option-secondary-container': {
            paddingLeft: 0,
            li: {
                color: fontColor.soft,
                lineHeight: font.lineHeight.base,
                fontFamily: font.base.family,
                fontWeight: font.base.weight.regular,
                fontSize: font.base.size.s,
                listStyleType: 'disc',
                float: 'left',
                marginLeft: spacing[2],
                marginTop: spacing[2],
                listStyle: 'none',
                '&:before': {
                    content: '"\\00b7"',
                    verticalAlign: 'middle',
                    marginRight: spacing[2],
                    color: fontColor.soft,
                    lineHeight: font.lineHeight.base,
                    fontFamily: font.base.family,
                    fontWeight: font.base.weight.regular,
                    fontSize: font.base.size.s
                },
                '&:first-of-type': {
                    marginLeft: 0,
                    '&:before': {
                        content: 'none'
                    }
                }
            }
        },
        'option-secondary-list-item': {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
        }
    };
};
export var useStyle = function(param) {
    var destructive = param.destructive, disabled = param.disabled, heading = param.heading, focused = param.focused, isRtl = param.isRtl, isSelected = param.isSelected;
    var style = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    });
    return useMemo(function() {
        return {
            firstOptionHeadingStyles: _objectSpread({}, style === null || style === void 0 ? void 0 : style['option-first-option-heading']),
            labelContainerStyles: _objectSpread({}, style === null || style === void 0 ? void 0 : style['option-label-container']),
            optionCheckStyles: _objectSpread({}, style === null || style === void 0 ? void 0 : style['option-check-style']),
            optionRowStyles: _objectSpread({}, style === null || style === void 0 ? void 0 : style['option-row-style']),
            lineBreakStyles: _objectSpread({}, style === null || style === void 0 ? void 0 : style['option-line-break']),
            listItemBackgroundStyles: _objectSpread({}, !(heading || disabled) && (style === null || style === void 0 ? void 0 : style['option-list-item-bg'])),
            listItemStyles: _objectSpread({}, style === null || style === void 0 ? void 0 : style['option-list-item'], heading && (style === null || style === void 0 ? void 0 : style['option-list-item-heading']), (heading || disabled) && (style === null || style === void 0 ? void 0 : style['option-list-item-bg-unset']), isSelected && (style === null || style === void 0 ? void 0 : style['option-list-item-selected'])),
            optionDestructiveStyles: _objectSpread({}, style === null || style === void 0 ? void 0 : style['option-destructive']),
            optionDisabledStyles: _objectSpread({}, style === null || style === void 0 ? void 0 : style['option-disabled']),
            optionHeadingStyles: _objectSpread({}, style === null || style === void 0 ? void 0 : style['option-heading']),
            secondaryContainerStyles: _objectSpread({}, style === null || style === void 0 ? void 0 : style['option-secondary-container']),
            secondaryListItemStyles: _objectSpread({}, style === null || style === void 0 ? void 0 : style['option-secondary-list-item'])
        };
    }, [
        destructive,
        disabled,
        heading,
        isSelected,
        style
    ]);
};
export default useStyle;
